import React from "react";
import Work from "@material-ui/icons/Work";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import styles from "./styles";
import Icon from "../../../components/Icon";

export const HelpSection = () => {
  const classes = styles();
  return (
    <div>
      <div className={classes.bannerBackground}>
        <div>
          <h2 className={classes.bannerTitle}>También puede necesitar</h2>
          <div>
            <Grid container spacing={3}>
              <Grid className={classes.pinted1} item xs={12} sm={4}>
                <div className={classes.itemContainer}>
                  <div className={"iconContainer"}>
                    <Icon
                      className={"iconMain"}
                      icon="plan-icon"
                      disableFill="true"
                    />
                  </div>
                  <div className={"textIcon"}>Conoce sobre tu plan </div>
                  <a href="#" className={"iconArrowContainer"}>
                    <ArrowDownward className={"iconArrow"} />
                  </a>
                </div>
              </Grid>
              <Grid className={classes.pinted2} item xs={12} sm={4}>
                <div className={classes.itemContainer}>
                  <div className={"iconContainer"}>
                    <Icon
                      className={"iconMain"}
                      icon="pdf-icon"
                      disableFill="true"
                    />
                  </div>
                  <div className={"textIcon"}>Guías y descargas</div>
                  <a href="#" className={"iconArrowContainer"}>
                    <ArrowDownward className={"iconArrow"} />
                  </a>
                </div>
              </Grid>
              <Grid className={classes.pinted3} item xs={12} sm={4}>
                <div className={classes.itemContainer}>
                  <div className={"iconContainer"}>
                    <Icon
                      className={"iconMain"}
                      icon="user-icon"
                      disableFill="true"
                    />
                  </div>
                  <div className={"textIcon"}>Ayuda personalizada</div>
                  <a href="#" className={"iconArrowContainer"}>
                    <ArrowDownward className={"iconArrow"} />
                  </a>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};
